import React, {useState, useEffect} from 'react';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

function LineItem (){
  const [Products, SetProducts] = useState([
    {
      id: '',
      name: '',
      description: '',
      retail_price: '',
      trade_price: '',
      product_type_type: '',
      product_type_id: '',
      image: ''
    }
  ]);
  const fetchProducts = async () => {
    try {
      const response = await fetch('http://127.0.0.1:3000/products.json');
      const data = await response.json(JSON.parse)
      SetProducts(data);
    }
    catch (err) {
      console.log(err)
    }
  }
  useEffect(() => {
    fetchProducts()
  }, [])

  const [LineItem, SetLineItem] = useState([
    {
      product_id: '',
      stock_type: '',
      quantity: '',
      length: '',
      width: '',
      consumable_type: '',
      consumable_quantity: ''
    }
  ])

  const [mode, setMode] = useState(false);
  const toggleMode = () => setMode(!mode);
  var stock_type = "";

  const SelectProductType =  () => {
    var product_select = document.getElementById('Product_Select');
    var product_id = product_select.options[product_select.selectedIndex].value;
    var product = Products.find(product => product.id == product_id);
    console.log(product_id)

    switch (product.product_type) {
      case "Carpet": stock_type = "StockFlooringRoll"
      break;

      case "Vinyl": stock_type = "StockFlooringRoll"
      break;

      case "Underlay": stock_type = "StockConsumable"
      break;

      case "Rug": stock_type = "StockConsumable"
      break;

      case "Gripper": stock_type = "StockConsumable"
      break;

      case "Blades": stock_type = "StockConsumable"
      break;

      case "Metals": stock_type = "StockConsumable"
      break;

      case "Glues": stock_type = "StockConsumable"
      break;
    }

    if (stock_type == "StockConsumable") {
      setMode(true);
    } else if (stock_type == "StockFlooringRoll"){
      setMode(false);
    }
  }

  return (
    <Form>
      <h1>New Line Item</h1>
      <Form.Text id="product_HelpBlock" muted>
          Select a product.
      </Form.Text>
      <FloatingLabel id="floating_product_label" label="Product" className="mb-3">
        <Form.Select
            className="mb-1"
            product='product'
            aria-describedby="product_HelpBlock"
            id="Product_Select"
            onChange={SelectProductType}
          >
          <option>Select a Product</option>
          {Products.map(fbb =>
            <option key={fbb.id} value={fbb.id}>{fbb.name}</option>
          )};
        </Form.Select>
      </FloatingLabel>

      {mode ?
      <div>
        <Row className="mb-3">
          <Form.Group as={Col}>
            <Form.Text id="d" muted>
              Enter the Quantity to order.
              <FloatingLabel id="label" label="Quantity" className='mb-3'>
                <Form.Control
                  type="number"
                  placeholder="Quantity"
                />
              </FloatingLabel>
            </Form.Text>
          </Form.Group>
          <Form.Group as={Col}>
            <Form.Text id="d" muted>
              Enter the Quantity to order.
              <FloatingLabel id="label" label="Consumable Type" className='mb-3'>
                <Form.Select>
                  <option value="1">Roll</option>
                  <option value="2">Box</option>
                  <option value="3">Length</option>
                </Form.Select>
              </FloatingLabel>
            </Form.Text>
          </Form.Group>
          <Form.Group as={Col}>
            <Form.Text id="d" muted>
              Enter the Quantity to order.
              <FloatingLabel id="label" label="Consumable Quantity" className='mb-3'>
                <Form.Control
                  type="number"
                  placeholder="Consumable Quantity"
                />
              </FloatingLabel>
            </Form.Text>
          </Form.Group>
        </Row>
      </div>
      :
      <div>
        <Row className="mb-3">
          <Form.Group as={Col}>
            <Form.Text id="Length_HelpBlock" muted>
              Enter the Length of the roll.
              <FloatingLabel id="floating_Length_label" label="Roll Length" className="mb-3">
                <Form.Control
                  placeholder="Length"
                  aria-describedby="Length_HelpBlock"
                />
              </FloatingLabel>
            </Form.Text>
          </Form.Group>
          <Form.Group as={Col}>
            <Form.Text id="Width_HelpBlock" muted>
              Enter the Width of the roll.
              <FloatingLabel id="floating_Width_label" label="Roll Width" className="mb-3">
                <Form.Control
                  placeholder="Width"
                  aria-describedby="Width_HelpBlock"
                />
              </FloatingLabel>
            </Form.Text>
          </Form.Group>
        </Row>
      </div>}
      <Button variant="secondary" type="button" className="mb-3" size="sm">Add Product to Order</Button>
    </Form>
  )
}
export default LineItem;
